import { render, staticRenderFns } from "./DrugAllocations.vue?vue&type=template&id=81c92636&"
import script from "./DrugAllocations.vue?vue&type=script&lang=js&"
export * from "./DrugAllocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports